import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useNetflixSelectionModalControls = () => {
    const { isModalOpen, closeModal, editModal, openModal } = useBrowserModalControls('netflix-selection');

    return {
        isNetflixSelectionModalOpen: isModalOpen,
        openNetflixSelectionModal: () => openModal(),
        closeNetflixSelectionModal: closeModal,
        editNetflixSelectionModal: editModal,
    };
};
